import { store } from '../../index'
import { reportError } from 'j-comps'
export { setApi } from './api'
export { getDesigns, createDesign, deleteDesign } from './designs'

export const resetState = () => {
  try {
    return store.dispatch({ type: 'RESET_STATE' })
  } catch (error) {
    const errorMessage = 'Could not reset state'
    return reportError(store, errorMessage, error)
  }
}

export const setMemberId = (memberId) => {
  try {
    return store.dispatch({ type: 'SET_MEMBER_ID', memberId })
  } catch (error) {
    const errorMessage = 'Could not set HS Member ID'
    return reportError(store, errorMessage, error)
  }
}

export const setStreamTab = (streamTab) => {
  try {
    return store.dispatch({ type: 'SET_STREAM_TAB', streamTab })
  } catch (error) {
    const errorMessage = 'Could not set Stream Tab'
    return reportError(store, errorMessage, error)
  }
}

export const setSource = (source) => {
  try {
    return store.dispatch({ type: 'SET_SOURCE', source })
  } catch (error) {
    const errorMessage = 'Could not set Source'
    return reportError(store, errorMessage, error)
  }
}
